// extracted by mini-css-extract-plugin
export default {"badge":"mPocgnts_VOcKhJe1Gnc"};